module.exports = __webpack_public_path__ + "static/media/project-stockify.703f504e.jpg";